import { Link } from "react-router-dom";
import { FeedbackCard } from "./FeedbackCard";
import { ROUTES } from "@/routes/routes.config";

export const AppEmptyState: React.FC<{
    message?: string, pageTitle?: string,
    paragraphClass?: string, isRedirection?: boolean,
    className?: string,
    minWidth?: string
}> = ({
    message = "No records found.",
    pageTitle = "Nothing to Display",
    paragraphClass = "text-center text-gray-500 font-medium",
    isRedirection = false,
    minWidth = "25vw",
    className = ""

}) => (
        <FeedbackCard className={className} minWidth={minWidth}>
            <div className="flex flex-col items-center justify-center">
                <div className="relative mb-6">
                    <div className="w-24 h-24 bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl flex items-center justify-center transform rotate-3 shadow-lg">
                        <i className="bi bi-file-earmark-x text-gray-400 text-5xl"></i>
                    </div>
                    <div className="absolute -top-2 -right-2 w-4 h-4 bg-blue-400 rounded-full animate-bounce opacity-60"></div>
                    <div
                        className="absolute -bottom-1 -left-1 w-3 h-3 bg-purple-400 rounded-full animate-bounce opacity-60"
                        style={{ animationDelay: '0.3s' }}
                    ></div>
                </div>

                <div className="text-center">
                    <h3 className="text-xl font-semibold text-[var(--color-gray-900]) mb-2">
                        {pageTitle}
                    </h3>
                    <p className={`${paragraphClass}`}>{message}</p>
                </div>
                {isRedirection && (
                    <Link
                        to={ROUTES.HOME}
                        className="mt-6 inline-flex items-center px-6 py-3 rounded-lg bg-primary text-white text-sm font-medium shadow-md hover:bg-primary-dark transition-colors"
                    >
                        Go to Product List
                    </Link>
                )}

            </div>
        </FeedbackCard>
    );
